<template>
    <div class="popup-overlay" v-if="visible">
      <div class="popup-content">
        <button class="close-btn" @click="closePopup">&times;</button>
  
        <!-- Responsive Banner Image -->
        <picture>
          <!-- แสดงเมื่อหน้าจอกว้างไม่เกิน 768px -->
          <source srcset="../assets/banner-mobile-3.jpg" media="(max-width: 768px)" />
          <!-- แสดงในหน้าจอปกติ (desktop) -->
          <img src="../assets/banner-3.jpg" alt="Popup Banner" class="popup-banner" />
        </picture>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Popup',
    data() {
      return {
        visible: true
      };
    },
    methods: {
      closePopup() {
        this.visible = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .popup-content {
    background: transparent;
    padding: 8px;
    text-align: center;
    position: relative;
    width: 100%;
    max-width: 1200px;
  }
  
  .popup-banner {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
  
  .close-btn {
    position: absolute;
    top: -10px;
    right: 12px;
    font-size: 50px;
    background: none;
    border: none;
    cursor: pointer;
    color: white;
  }
  </style>
  